import { IStore } from '../../store';
import { TANNEX6Actions } from './actions';
import { IAuthActions } from '../auth/actions';
import annex6HistoryMiddleware from './middlewares/history.middleware';
import createMiddleware from '../../_core/create-middleware';

const annex6BaseMiddleware = createMiddleware<
    IStore,
    TANNEX6Actions | IAuthActions
>()
    .getMiddleware();

const annex6Middlewares = [
    annex6BaseMiddleware,
    annex6HistoryMiddleware,
];

export default annex6Middlewares;
